import doctorConfig from './doctor/system.config.js';
import shopConfig from './shop/system.config.js';
import restaurantConfig from './restaurant/system.config.js';
import taxiConfig from './taxi/system.config.js';

/**
 * systemRegistry.js
 *
 * Maps a system id to its local config file. Bootstrap looks up this
 * registry once, by id, to merge local metadata (brandIcon,
 * defaultModule, footerNote) with whatever the backend returned. To
 * introduce system #5 you add one config file + one line here — no
 * component ever needs an `if (systemId === '...')` branch.
 */
const SYSTEM_REGISTRY = {
  doctor: doctorConfig,
  shop: shopConfig,
  restaurant: restaurantConfig,
  taxi: taxiConfig,
};

export function getSystemConfig(systemId) {
  return (
    SYSTEM_REGISTRY[systemId] ?? {
      id: systemId,
      brandIcon: '⚙️',
      defaultModule: null,
      footerNote: '',
    }
  );
}
